<template>
	<div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="customer_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('customer')">
                            <customers-auto-complete v-model="formData.customer_id"
                                                 :validateError="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider
                        name="academic_year"
                        rules=""
                        v-slot="{ valid, errors }"
                    >
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox
                                v-model="formData.academic_year"
                                :validate-error="errors[0]"
                            ></academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="amount" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('amount')">
                            <b-form-input
                                type="number"
                                min="0" step=".01"
                                v-check-min-max-value
                                v-model="formData.amount"
                            ></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="currency" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('currency')">
                            <currency-selectbox
                                :validate-error="errors[0]"
                                v-model="formData.currency"
                            ></currency-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="issue_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('issue_date')">
                            <select-date v-model="formData.issue_date" :is-time="false" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="subject" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('subject')">
                            <b-form-textarea v-model="formData.subject"
                                             :class="errors[0] ? 'is-invalid':''"
                                             rows="6" />
                            <span class="invalid-feedback-custom" v-show="errors[0]" v-html="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-2">
                <b-button variant="primary"
                          @click="createForm"
                          :disabled="formLoading">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
	</div>
</template>

<script>
	// Components
    import CustomersAutoComplete from "@/components/interactive-fields/CustomersAutoComplete.vue";
    import CurrencySelectbox from "@/components/interactive-fields/CurrencySelectbox.vue";
    import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox";

	// Services
    import CustomerBudgetService from "@/services/CustomerBudgetService";

	// Other
	import {ValidationProvider, ValidationObserver} from "vee-validate"

	export default {
		components: {
            CurrencySelectbox,
            AcademicYearsSelectbox,
            CustomersAutoComplete,
			ValidationProvider,
			ValidationObserver,

		},
		data() {
			return {
				formData: {
                    customer_id: null,
                    issue_date: null,
                    subject: null,
                    amount: null,
                    currency: null,
                    academic_year: null,
				},
				formLoading: false,
			}
		},
		methods: {
			async createForm() {
				const isValid = await this.$refs.formModalValidate.validate();
				if (isValid) {
					this.formLoading = true;
					CustomerBudgetService.store(this.formData)
					             .then(response => {
						             this.$toast.success(this.$t('api.' + response.data.message));
						             this.$emit('createFormSuccess', true);
					             })
					             .catch(e => {
						             this.showErrors(e, this.$refs.formModalValidate);
					             })
					             .finally(() => {
						             this.formLoading = false
					             })
				}
			}
		}
	}
</script>

